import { initialState, slice } from "./Slice";

const { actions } = slice;

export const saveAnswers = (Answers) => dispatch => {
    dispatch(actions.choice({ Answers }))
}

export const saveChangeTimeTable = (TimeTableSave) => dispatch => {
    dispatch(actions.choice({ TimeTableSave }))
}

export const saveUser = (user) => dispatch => {
    dispatch(actions.choice({ user }))
}

export const saveRefreshSocket = (datasocket) => dispatch => {
    dispatch(actions.choice({ datasocket }))
}
export const saveListYear = (listyear) => dispatch => {
    dispatch(actions.choice({ listyear }))
}

export const saveRedux = (state) => dispatch => {

    dispatch(actions.choice(state))
}
export const resetRedux = () => dispatch => {
    dispatch(actions.choice(initialState))
}
export const saveComment = (savecomment) => dispatch => {
    dispatch(actions.choice({ savecomment }))
}
export const saveLike = (saveLike) => dispatch => {
    dispatch(actions.choice({ saveLike }))
}
export const setResetPost = (resetpost) => dispatch => {
    dispatch(actions.choice({ resetpost }))
}
export const saveNotification = (notification) => dispatch => {
    dispatch(actions.choice({ notification }))
}
export const saveBookingStatus = (bookingstatus) => dispatch => {
    dispatch(actions.choice({ bookingstatus }))
}
export const saveBookingCarStatus = (carBookingStatus) => dispatch => {
    dispatch(actions.choice({ carBookingStatus }))
}
export const saveCountCV = (countcv) => dispatch => {
    dispatch(actions.choice({ countcv }))
}
export const savePosts = (savePosts) => dispatch => {
    dispatch(actions.choice({ savePosts }))
}
export const saveWorkfollow = (saveWorkfollow) => dispatch => {
    dispatch(actions.choice({ saveWorkfollow }))
}